import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed, onUnmounted, onBeforeUnmount, watch, watchEffect } from "vue";
import { debug as d } from "debug";
import { CompositeHeadApiModel } from "../../../api-models";
import ThreeHeadTooltip from "./three-head-tooltip.vue";
import { SoloOrViewpointsOption } from "./nodes-and-links-models";
import useNodesAndLinksCurrentData from "./use-nodes-and-links-data";
import useNodesAndLinksGraph from "./use-nodes-and-links-graph";
import { graphOptions } from "./3d-node-renderer";


export default /*#__PURE__*/_defineComponent({
  __name: 'head-canvas',
  props: {
    expanded: { type: Boolean },
    model: {}
  },
  setup(__props: any) {

const debug = d("cs.heatmaps");

const soloOrViewpoints = ref<SoloOrViewpointsOption>("solo");

const props = __props;

const canvasWrapper = ref<HTMLElement>();
const element = ref<HTMLElement>();
const size = ref<{ width: number; height: number }>();
const isResizing = ref(false);

const currentParentNode = computed(() => {
  return props.expanded ? props.model!.rootNode : null;
});

const { data: heatmapData } = useNodesAndLinksCurrentData(props.model!, currentParentNode);
const { graph, selectedNode, hoveredNode, autoRotate, tooltipRenderer } = useNodesAndLinksGraph(
  heatmapData,
  canvasWrapper,
  size,
  isResizing,
  soloOrViewpoints,
);

function updateSize() {
  debug("updateSize");
  const { width, height } = element.value!.getBoundingClientRect();
  debug("new size", { width, height });
  size.value = { width, height };
  isResizing.value = false;
}

let resizeTimeout: any | null = null;

function onWindowResize() {
  debug("onWindowResize");
  isResizing.value = true;
  // Use a simple debounce to avoid repeated work during prolonged resize
  if (resizeTimeout) clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    updateSize();
  }, 500);
}

const resizeObserver = new ResizeObserver(updateSize);

onMounted(() => {
  window.addEventListener("resize", onWindowResize);
  resizeObserver.observe(element.value!);
  updateSize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onWindowResize);
  resizeObserver.unobserve(element.value!);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: "head-canvas"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["canvas-wrapper", { resizing: isResizing.value }]),
      ref_key: "canvasWrapper",
      ref: canvasWrapper
    }, null, 2),
    (_unref(graph))
      ? (_openBlock(), _createBlock(ThreeHeadTooltip, {
          key: 0,
          type: "Solo",
          graph: _unref(graph),
          renderer: _unref(tooltipRenderer),
          "hovered-node": _unref(hoveredNode),
          "selected-node": _unref(selectedNode),
          enabled: !!_unref(hoveredNode) && !_unref(autoRotate)
        }, null, 8, ["graph", "renderer", "hovered-node", "selected-node", "enabled"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})